import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import { Typography } from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import { Skeleton } from '@material-ui/lab';
import { useQuery } from 'react-query';
import neshan from '../../../../../api/neshan';
import { formatNumber } from 'fns';
import useToast from 'hooks/useToast';
import { useHistory } from 'react-router-dom';
import { toFA } from 'fns/toFA';

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: 'auto',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    '& .isVerified': {
      backgroundColor: 'lightGreen',
      padding: '0 8px',
      borderRadius: '3px',
      '& .text': {
        fontSize: '11px',
        whiteSpace: 'nowrap',
      },
    },
  },
  small: {
    width: '35px',
    height: '35px',
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingRight: '0px !important',
    width: '100%',
    alignItems: 'center',
  },
}));

const BidderItem = ({ bid }) => {
  const toast = useToast();
  const classes = useStyles();
  const history = useHistory();
  const loadLocation = async (coordinates) => {
    if (!coordinates) return;
    try {
      const { data } = await neshan.get(
        `/v2/reverse?lat=${coordinates?.[0]}&lng=${coordinates?.[1]}`
      );
      return data?.formatted_address;
    } catch (error) {
      toast.error(error);
      console.error(error);
    }
  };

  const { data, isLoading } = useQuery(
    ['location', bid?.orderId, bid?.driver?.location?.coordinates],
    () => loadLocation(bid?.driver?.location?.coordinates)
  );

  const handleRedirectToDriver = async () => {
    history.push(`/protected/admin/users/driver/${bid?.driver?._id}`);
  };

  return (
    <div>
      <ListItem className={classes.root}>
        <div
          onClick={handleRedirectToDriver}
          className={classes.item + ' cursor-pointer'}
        >
          <ListItemAvatar>
            <Avatar />
          </ListItemAvatar>
          <ListItemText
            primary={bid.driver.lastName}
            secondary={`${bid.driver?.fleetOptions?.[0]?.fleet?.title} ${bid.driver?.fleetOptions?.[0]?.title}`}
          />

          <div>
            <Typography className="isVerified orange textWhtie">{`${toFA(
              formatNumber(bid.bid)
            )} تومان`}</Typography>
            {bid.driver && (
              <div className="isVerified mt-1">
                <Typography className="text"> احراز هویت شده</Typography>
              </div>
            )}
          </div>
        </div>

        <a href={`tel:${bid.driver.mobilePhone}`}>
          <ListItemAvatar>
            <Avatar className={'whatsapp textWhite me-2 ' + classes.small}>
              <CallIcon fontSize="small" />
            </Avatar>
          </ListItemAvatar>
        </a>
      </ListItem>
      <div className="mb-2 mx-4 ">
        {isLoading && !data ? (
          <Skeleton className="w-100" variant="text" height={20} />
        ) : !isLoading && !data ? (
          <div>موقعیت راننده وجود ندارد</div>
        ) : (
          <Typography style={{ fontSize: 12, color: 'gray' }}>
            {data}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default BidderItem;
